import { toggleLoadingIndicator } from "../system/actions";
import { MessageResponse } from "../system/types";
import { AppThunk } from "../thunks";
import { setMessageResponse } from "../system/actions";
import { serverMessages } from "../serverMessages";
import { addFirstName,addId,addLastName, addRol } from "../user/actions";
import { RegisterUser, UserLoginState } from "./types";
import { getUserByTokenAPI, postLoginUserAPI,getAllUsersTableAPI,postResgisterUserAPI ,getUserByIdAPI
,putUpdateUserAPI,getValidateUserAPI,deleteInactiveUserAPI,putActiveUserAPI,putResetPasswordAPI,putUpdatePasswordAPI,
deleteUserByIdAPI,
putUpdateAdminPasswordAPI,getAllActiveGroupAPI,
getOrganizationsUserAPI,
postOrganizationsUserAPI,
deleteOrganizationsUserAPI,
getAllModuleTokenWithUserAPI} from "../../services/restcall";
import { login, loginCookie } from "../../services/auth";
import validateMessages from "../../globals/Inputs/validateMessages";
import { openNotification } from "../../globals/Components/Notification/Notificaction";
import configureApiRestService from "../../services/apiService";
import { addNameOrganization } from "../organization/actions";
import { getAllModuleTokenAPI, getAllUsersPortfolioTableAPI } from "./restCallUser";


export const getAllUsersPortfolioTable = (value:string): AppThunk => async (dispatch) => {
    
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getAllUsersPortfolioTableAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getAllModuleToken = (): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getAllModuleTokenAPI();
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {   
        dispatch(setMessageResponse(null));  
        dispatch(toggleLoadingIndicator(false));   
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};


export const deleteUserById = (value:string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await deleteUserByIdAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
        openNotification("Advertencia",message.message[0]);  
    }
    else if (responseData.StatusCode === 200) {           
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));  
        openNotification("Usuario",validateMessages.deleteSuccess);           
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const postOrganizationsUser = (accountLoginState: UserLoginState): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await postOrganizationsUserAPI(accountLoginState);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));      
        return responseData.Response; 
    }
    dispatch(toggleLoadingIndicator(false));
};




export const deleteOrganizationsUser = (value: string, value2:string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await deleteOrganizationsUserAPI(value, value2);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));      
        return responseData.Response; 
    }
    dispatch(toggleLoadingIndicator(false));
};
export const postAccountLoginUser = (accountLoginState: UserLoginState): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await postLoginUserAPI(accountLoginState);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        
        loginCookie(responseData.Response.access_token);
        login(responseData.Response.access_token);
        const token = {
            token: responseData.Response.access_token   
        };
        const responseDataRespone = await getAllModuleTokenWithUserAPI(token);

        window.location.replace(process.env.REACT_APP_BASE_URL as string+"/"+responseDataRespone.Response[0].link);
        dispatch(setMessageResponse(null));
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getUserByToken = (): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getUserByTokenAPI();
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(addNameOrganization(responseData.Response.organization));           
        dispatch(addFirstName(responseData.Response.fullname));       
        dispatch(addId(responseData.Response.id));      
        dispatch(addRol(responseData.Response.rol))       
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response.rol;
    }
    dispatch(toggleLoadingIndicator(false));
};
export const getUserByTokenAll = (): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getUserByTokenAPI();
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {          
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};



export const getOrganizationsUser = (value:string): AppThunk => async (dispatch) => {
    
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getOrganizationsUserAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};
export const getUserById = (value:string): AppThunk => async (dispatch) => {
    
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getUserByIdAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getAllUsersTable = (): AppThunk => async (dispatch) => {
    
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getAllUsersTableAPI();
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};
export const postResgisterUser = (registerUser:RegisterUser): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));

    const responseData = await postResgisterUserAPI(registerUser);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);     
        openNotification("Advertencia",message.message[0]);   
    }
    else if (responseData.StatusCode === 200) {
   
        openNotification("Ingreso","Usuario "+validateMessages.registerSuccess);  
        dispatch(toggleLoadingIndicator(false));       
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};


export const putUpdateUser = (registerUser:RegisterUser): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));  
    const responseData = await putUpdateUserAPI(registerUser);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        openNotification("Advertencia",message.message[0]);       
        
    }
    else if (responseData.StatusCode === 200) {        
        dispatch(toggleLoadingIndicator(false));
        openNotification("Actualización","Usuario "+ validateMessages.updateSuccess);    
        dispatch(toggleLoadingIndicator(false));     
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};


export const putResetPassword = (registerUser:RegisterUser): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));  
    const responseData = await putResetPasswordAPI(registerUser);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        openNotification("Advertencia",message.message[0]);       
        
    }
    else if (responseData.StatusCode === 200) {        
        dispatch(toggleLoadingIndicator(false));
        openNotification("Actualización","Usuario "+ validateMessages.updateSuccess);    
        dispatch(toggleLoadingIndicator(false));     
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const putActiveUser = (registerUser:RegisterUser): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));  
    const responseData = await putActiveUserAPI(registerUser);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        openNotification("Advertencia",message.message[0]);       
        
    }
    else if (responseData.StatusCode === 200) {        
        dispatch(toggleLoadingIndicator(false));
        openNotification("Actualización","Usuario "+ validateMessages.updateSuccess);    
        dispatch(toggleLoadingIndicator(false));     
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};


export const deleteInactiveUser = (value: String): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await deleteInactiveUserAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {           
        dispatch(setMessageResponse(null));
        openNotification("Actualización","Usuario "+ validateMessages.updateSuccess);    
        dispatch(toggleLoadingIndicator(false));       
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getValidateUser = (email: String): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getValidateUserAPI(email);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {           
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));       
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const putUpdatePassword = (registerUser:RegisterUser): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));      
    const responseData = await putUpdatePasswordAPI(registerUser);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));      
        
    }
    else if (responseData.StatusCode === 200) {        
        dispatch(toggleLoadingIndicator(false));
        openNotification("Actualización","Usuario "+ validateMessages.updateSuccess);    
        dispatch(toggleLoadingIndicator(false));     
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};


export const putUpdateAdminPassword = (registerUser:RegisterUser): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));  
    const responseData = await putUpdateAdminPasswordAPI(registerUser);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));      
        
    }
    else if (responseData.StatusCode === 200) {        
        dispatch(toggleLoadingIndicator(false));
        openNotification("Actualización","Usuario "+ validateMessages.updateSuccess);    
        dispatch(toggleLoadingIndicator(false));     
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getAllActiveGroup = (): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getAllActiveGroupAPI();
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {           
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));       
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};